export const formatButtonText = (text) => {
  if (!text) return text
  const pattern = /(\[\d+\]\s*)+$/ // Matches trailing numeric patterns in square brackets
  return text.replace(pattern, "").trim() // Trim removes any trailing spaces after replacement
}
